
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meeting-event-hotels/[[...page]]",
      function () {
        return require("private-next-pages/meeting-event-hotels/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meeting-event-hotels/[[...page]]"])
      });
    }
  